import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeopleHelpModalComponent } from './people-help-modal.component';
import {ButtonModule} from "@xref/xref-lib";



@NgModule({
  declarations: [PeopleHelpModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [PeopleHelpModalComponent],
})
export class PeopleHelpModalModule { }
